module.exports = __webpack_public_path__ + "img/new-dc.457779dc.svg";